/**
 * Where a looping wall tile should be right now: the clip has been looping since
 * the epoch, so the position is the time since the epoch modulo the clip length.
 * A tile that starts 40 s after the epoch with a 30 s clip belongs at 10 s.
 */
export function wallTimelinePositionSeconds(serverNowMs, epochMs, durationSeconds) {
    if (!Number.isFinite(durationSeconds) || durationSeconds <= 0)
        return 0;
    const elapsedSeconds = (serverNowMs - epochMs) / 1000;
    if (!Number.isFinite(elapsedSeconds) || elapsedSeconds <= 0)
        return 0;
    return elapsedSeconds % durationSeconds;
}
//# sourceMappingURL=wall-timeline.js.map